/**
 * 
 * @param {HTMLScriptElement[]} scripts An array of <script> elements to wait for
 * @param {number} timeout Timeout duration in ms
 */
export const waitForScripts = async (
  scripts,
  timeout = 3000
) => {
  const winner = await Promise.race([
    new Promise((resolve) =>
      setTimeout(() => {
        resolve("timeout");
      }, timeout)
    ),
    new Promise((resolve) => {
      let count = 0;
      const incrementAndResolveIfFinished = () => {
        if (++count >= scripts.length) {
          resolve("scripts");
        }
      };

      if (scripts.length === 0) {
        resolve("scripts");
      } else {
        scripts.forEach((script) =>
          script.addEventListener("load", () => {
            incrementAndResolveIfFinished();
          })
        );
      }
    }),
  ]);

  if (winner === "timeout") {
    console.warn(`[FNC] waitForScripts called but timed out`);
  }
};

export const allNodeNamesFromRoot = root => {
  const traverse = node => [
    node.nodeName.toLowerCase(),
    ...Array.from(node.children || []).map(traverse).flat()
  ];

  return [...new Set([...traverse(root)])];
};

export const obtainRegisteredCustomElementContainer = (el) => {
  // Idea borrowed and adapted from the Vue source: https://github.com/vuejs/core/blob/main/packages/runtime-dom/src/apiCustomElement.ts#L400-L413
  let currentNode = el;
  while (!currentNode.contextRegistered && (currentNode.parentNode || currentNode.host)) {
    currentNode = currentNode.parentNode || currentNode.host;
  }
  return currentNode.contextRegistered ? currentNode : undefined;
};

export const obtainNearestRootElement = (el) => {
  let currentNode = el.parentNode || el.host;
  while (!currentNode.contextRegistered && !currentNode.root && (currentNode.parentNode || currentNode.host)) {
    currentNode = currentNode.parentNode || currentNode.host;
  }
  return (currentNode.contextRegistered && currentNode.root) ? currentNode : undefined;
};